import { useNavigate } from 'react-router-dom'
import exito from '../../assets/img/success.png'
import ActionCard from '../../components/SharedLayouts/ActionLayout/ActionCard'

const UnsubscribeSuccess = () => {
    const navigate = useNavigate();

    const goToHome = () => {
        navigate('monitor')
    }

    return (
        <ActionCard
            image={exito}
            alt="exito"
            title="¡Tu baja fue procesada con éxito!"
            description="Ya no recibirás más novedades del Monitor de Derechos. Si en el futuro querés volver a suscribirte, podés hacerlo desde nuestra web."
            buttonLabel="Volver al inicio"
            onClick={goToHome}
            buttonDisabled={false}
        />
    )
}

export default UnsubscribeSuccess